export default "__VITE_ASSET__4049ae23__"